export default __webpack_public_path__ + "media/images/svg/ico-menu-1de76cd3ca4ee05b7475b24c57297efd.svg";